import { DeleteOutline, Add } from "@mui/icons-material";
import {
  Typography,
  Box,
  FormControl,
  Select,
  MenuItem,
  TextField,
  IconButton,
  Button,
} from "@mui/material";
import { propertyDetailsTypes } from "../../../../utils/Constant";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { phoneFormatInput } from "../../../../utils/Formatter";

const labelAboveSx = {
  fontSize: 12,
  color: "rgba(0, 0, 0, 0.6)",
  mb: 0.5,
};
const inputBgSx = {
  "& .MuiOutlinedInput-root": {
    backgroundColor: "#FAFAFA",
  },
};

export default function OptionalPropertyDetails({
  optionalPropertyDetails,
  formik,
  addOptionalDetails,
  updateOptionalDetailsType,
  updateOptionalDetailsDescription,
  removeOptionalDetails,
  disabled = false,
}: any) {
  return (
    <>
      <Typography sx={{ ...labelAboveSx, mt: 2, mb: 1 }}>
        Optional Property Details
      </Typography>
      {optionalPropertyDetails.length > 0 && (
        <Box display={"flex"}>
          <Typography sx={{ flex: 1 }}>
            <b>Type</b>
          </Typography>
          <Typography sx={{ flex: 3, ml: 2 }}>
            <b>Description</b>
          </Typography>
        </Box>
      )}
      {optionalPropertyDetails.map((details: any, index: number) => {
        return (
          <Box display={"flex"} mt={2} key={index}>
            <FormControl
              sx={{ flex: 1, ...inputBgSx }}
              size="small"
              //   onBlur={() => {
              //     formik.setFieldTouched(
              //       `optionalPropertyDetails.${index}.type`,
              //       true
              //     );
              //     setTimeout(
              //       () =>
              //         formik.validateField(
              //           `optionalPropertyDetails.${index}.type`
              //         ),
              //       0
              //     );
              //   }}
              error={Boolean(
                (formik.touched.propertyRecord?.optionalPropertyDetails?.[index] as any)
                  ?.type &&
                  (formik.errors.propertyRecord?.optionalPropertyDetails?.[index] as any)?.type
              )}
              disabled={disabled}
            >
              <Select
                value={details?.type}
                onChange={(e) =>
                  updateOptionalDetailsType(e.target.value, index)
                }
                displayEmpty
                inputProps={{ "aria-label": "Without label" }}
              >
                {propertyDetailsTypes.map((type) => (
                  <MenuItem
                    key={type?.value}
                    value={type?.value}
                    disabled={
                      optionalPropertyDetails.filter(
                        (item: any, itemIndex: number) =>
                          item?.type === type?.value && itemIndex !== index
                      ).length > 0
                        ? true
                        : false
                    }
                  >
                    {type?.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <Box sx={{ display: "flex", alignItems: "center", flex: 3, ml: 2 }}>
              {(details?.type === "accountNumber" ||
                details?.type === "referenceNumber" ||
                details?.type === "collateralOrPropertyDescription" ||
                details?.type === "collateralOrPropertyType" ||
                details?.type === "nameOfBusiness" ||
                details?.type === "businessPhone" ||
                details?.type === "investorNumber" ||
                details?.type === "obligor" ||
                details?.type === "obligation" ||
                details?.type === "borrower" ||
                details?.type === "dealerGroup" ||
                details?.type === "dropDeadDate" ||
                details?.type === "investorLoanNumber" ||
                details?.type === "investorName" ||
                details?.type === "netRentableSquareFootage" ||
                details?.type === "assetManager" ||
                details?.type === "assetManagerEmail" ||
                details?.type === "assetManagerPhone" ||
                details?.type?.startsWith("operationsAndMaintenance") ||
                details?.type?.startsWith("repair") ||
                details?.type === "") && (
                <TextField
                  sx={{ ...inputBgSx }}
                  size="small"
                  fullWidth
                  id="description"
                  variant="outlined"
                  value={details?.description}
                  onChange={(e) => {
                    let value = e.target.value;
                    if (details?.type === "businessPhone") {
                      value = phoneFormatInput(value);
                    }
                    updateOptionalDetailsDescription(value, index);
                  }}
                  //   onBlur={() => {
                  //     formik.setFieldTouched(
                  //       `optionalPropertyDetails.${index}.description`,
                  //       true
                  //     );
                  //     setTimeout(
                  //       () =>
                  //         formik.validateField(
                  //           `optionalPropertyDetails.${index}.description`
                  //         ),
                  //       0
                  //     );
                  //   }}
                  error={Boolean(
                    (formik.touched.propertyRecord?.optionalPropertyDetails?.[index] as any)
                      ?.description &&
                      (formik.errors.propertyRecord?.optionalPropertyDetails?.[index] as any)
                        ?.description
                  )}
                  helperText={
                    (formik.touched.propertyRecord?.optionalPropertyDetails?.[index] as any)
                      ?.description &&
                    (formik.errors.propertyRecord?.optionalPropertyDetails?.[index] as any)
                      ?.description
                      ? String(
                          (
                            formik.errors.propertyRecord?.optionalPropertyDetails?.[
                              index
                            ] as any
                          )?.description
                        )
                      : ""
                  }
                  disabled={disabled}
                />
              )}

              {(details?.type === "yearBuilt" ||
                details?.type === "yearRenovated" ||
                details?.type === "numberOfUnits" ||
                details?.type === "numberOfBuildings" ||
                details?.type === "squareFootage" ||
                details?.type === "loanBalance") && (
                <TextField
                  sx={{
                    ...inputBgSx,
                    "& input[type=number]": {
                      "-moz-appearance": "textfield",
                    },
                    "& input[type=number]::-webkit-outer-spin-button": {
                      "-webkit-appearance": "none",
                      margin: 0,
                    },
                    "& input[type=number]::-webkit-inner-spin-button": {
                      "-webkit-appearance": "none",
                      margin: 0,
                    },
                  }}
                  size="small"
                  fullWidth
                  id="description"
                  type="number"
                  variant="outlined"
                  value={details?.description}
                  onChange={(e) =>
                    updateOptionalDetailsDescription(e.target.value, index)
                  }
                  //   onBlur={() => {
                  //     formik.setFieldTouched(
                  //       `optionalPropertyDetails.${index}.description`,
                  //       true
                  //     );
                  //     setTimeout(
                  //       () =>
                  //         formik.validateField(
                  //           `optionalPropertyDetails.${index}.description`
                  //         ),
                  //       0
                  //     );
                  //   }}
                  error={Boolean(
                    (formik.touched.propertyRecord?.optionalPropertyDetails?.[index] as any)
                      ?.description &&
                      (formik.errors.propertyRecord?.optionalPropertyDetails?.[index] as any)
                        ?.description
                  )}
                  helperText={
                    (formik.touched.propertyRecord?.optionalPropertyDetails?.[index] as any)
                      ?.description &&
                    (formik.errors.propertyRecord?.optionalPropertyDetails?.[index] as any)
                      ?.description
                      ? String(
                          (
                            formik.errors.propertyRecord?.optionalPropertyDetails?.[
                              index
                            ] as any
                          )?.description
                        )
                      : ""
                  }
                  onKeyDown={(e) => {
                    if (
                      e.key === "-" ||
                      e.key === "e" ||
                      e.key === "E" ||
                      e.key === "+"
                    ) {
                      e.preventDefault();
                    }
                  }}
                  disabled={disabled}
                />
              )}

              {details?.type === "operationsAndMaintenanceRequired" && (
                <FormControl
                  sx={{ flex: 1, ...inputBgSx }}
                  size="small"
                  //   onBlur={() => {
                  //     formik.setFieldTouched(
                  //       `optionalPropertyDetails.${index}.description`,
                  //       true
                  //     );
                  //     setTimeout(
                  //       () =>
                  //         formik.validateField(
                  //           `optionalPropertyDetails.${index}.description`
                  //         ),
                  //       0
                  //     );
                  //   }}
                  error={Boolean(
                    (formik.touched.propertyRecord?.optionalPropertyDetails?.[index] as any)
                      ?.description &&
                      (formik.errors.propertyRecord?.optionalPropertyDetails?.[index] as any)
                        ?.description
                  )}
                  disabled={disabled}
                >
                  <Select
                    value={details?.description}
                    onChange={(e) =>
                      updateOptionalDetailsDescription(e.target.value, index)
                    }
                    displayEmpty
                    inputProps={{ "aria-label": "Without label" }}
                  >
                    <MenuItem value={"true"}>True</MenuItem>
                    <MenuItem value={"false"}>False</MenuItem>
                  </Select>
                </FormControl>
              )}

              {details?.type === "loanBalanceAsOf" && (
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    sx={{
                      flex: 1,
                      ...inputBgSx,
                      "& .MuiOutlinedInput-input": { padding: "8.5px 14px" },
                    }}
                    value={
                      details?.description ? dayjs(details?.description) : null
                    }
                    onChange={(date) => {
                      const dateValue = date?.format("YYYY-MM-DD");
                      updateOptionalDetailsDescription(dateValue, index);
                    }}
                    slotProps={{
                      textField: {
                        variant: "outlined",
                        error:
                          formik.touched.loanBalanceAsOf &&
                          Boolean(formik.errors.loanBalanceAsOf),
                        helperText:
                          formik.touched.loanBalanceAsOf &&
                          formik.errors.loanBalanceAsOf
                            ? String(formik.errors.loanBalanceAsOf)
                            : "",
                      },
                    }}
                    disabled={disabled}
                  />
                </LocalizationProvider>
              )}

              <IconButton
                onClick={() => removeOptionalDetails(index)}
                sx={{ color: "error.main", ml: 2, height: 30, mr: 1 }}
                size="small"
                aria-label="delete optional details"
                disabled={disabled}
              >
                <DeleteOutline fontSize="small" />
              </IconButton>
            </Box>
          </Box>
        );
      })}
      {optionalPropertyDetails.length < propertyDetailsTypes.length && (
        <Button
          startIcon={<Add sx={{ width: 18, height: 18 }} />}
          onClick={addOptionalDetails}
          sx={{
            mt: optionalPropertyDetails.length === 0 ? 0 : 2,
            color: "primary.main",
            fontWeight: 13,
            alignItems: "center",
            "&:hover": { backgroundColor: "transparent" },
          }}
          disabled={disabled}
        >
          <b>Add Optional Property Details</b>
        </Button>
      )}
    </>
  );
}
